export const TranslationKeys: { readonly [key: string]: string } = {
  NAMESPACE: 'Text_Input',
  PHONE_FORMAT_LENGTH_VALIDATION_ERROR:
    'text_input_phone_format_length_validation_error',
  PHONE_FORMAT_LENGTH_VALIDATION_ERROR_DEFAULT:
    'Please enter a phone number with {digits} digits',
};
